var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApplicationLayout',[_c('v-container',{attrs:{"fluid":"","px-12":"","py-6":""}},[_c('ProductsList',{attrs:{"title":"Products","title-classname":"display-1"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }